(function () {

  'use strict';


  function pxPrintRules(
    PrintQueueListPaging, PrintRulesService, URLS, URL_PARAMS, $location, PrintQueueListService,
    PrinterListService, GroupListService, $timeout, toastr, $filter, TenantModel,
    $rootScope, EventServiceEvents, $q, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: "=tenant",
        me: "=me"
      },
      templateUrl: 'app/components/settings/printRules/printRules.template.html',
      link: function (scope) {

        scope.printRuleConfigPrevious = {};
        scope.thresholdRegex = /^[0-9]+$/

        scope.isLoading = false;
        scope.selection = {
          doubleSideOption: 'all',
          blackWhiteOption: 'all',
        }
        scope.printRuleConfig = null;

        (function() {
          scope.groupsEnabled = scope.tenant.info.groupsEnabled;
          getPrintRules();
        })();

        scope.handleSelection = function (type, event) {
          scope.setRuleSelections(type, event);
        }

        scope.setRuleSelections = function(type, event = false) {
          const isBlackWhite = type === 'BLACK_AND_WHITE';
          const rule = scope.printRuleConfig.rules[type];
          const selection = isBlackWhite ? 'blackWhiteOption' : 'doubleSideOption';
          // There are no groups selected so we need to open the groups menu so they can make a selection
          if ( !rule.groups.length ) {
            if (scope.selection[selection] === 'all') {
              scope.selection[selection] = 'all';
              return;
            }
            scope.selection[selection] = 'all';

            if ( event ){
              const menuOption = { type: 'addPrintRulesGroups' }
              const context = {
                name: 'AddGroups',
                dontUseTitle: true,
                type: 'addPrintRulesGroups',
                breaker: false,
                groups: isBlackWhite ? 'BlackAndWhiteGroup' : 'DoubleSideGroup'
              };
              scope.openContextMenu(event, context, menuOption);
            }
          } else {

            if (scope.selection[selection] === 'all') {
              scope.selection[selection] = 'groups';
              if (event) {
                scope.updateGroups({ delete: rule.groups }, isBlackWhite)
              }
            } else {
              scope.selection[selection] = 'groups';
            }
          }
        }

        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'groups':
                groupTooltip(position, tooltipScope);
                break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function groupTooltip (position, title) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'RulesInfoEnableGroups',
            type: 'statement'
          }
          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20},
            contextMenu: false
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

        //NEW CONTEXT MENUS
        scope.openContextMenu = function (event, context, menuOption){

          $timeout(function  () {
            if (event && context && menuOption) {
              scope.selectedContextMenuItem  =  menuOption;
              scope.contextPosition = { left: event.clientX, top: event.clientY }
              scope.context = context;
              scope.resource = scope.tenant;
            } else {
              scope.selectedContextMenuItem  =  null;
              scope.contextPosition = null;
              scope.context = null;
            }
          }, 50)
        }

        scope.openGroupsMenu = function (event, context) {

          var menuItems = [
            {title: 'Groups', selected: false, type: 'showPrintRulesGroupList', breaker: false},
            {title: 'AddGroups', selected: false, type: 'addPrintRulesGroups', breaker: false, bypassCloseOutside: true, disabled: scope.me.isSystemObserver()},
            {title: 'RemoveGroups', selected: false, type: 'removePrintRulesGroups', breaker: true, disabled: scope.me.isSystemObserver()},
          ];
          var icon = 'icon-group';

          context.name = $filter("translate")(context.name);

          scope.closeAllMenus();

          $timeout(function () {
            scope.groupsMenuContent = {
              menuItems: menuItems,
              context: context,
              icon: icon,
              sizeClass: 'size115',
              type: 'ALLROUND'
            }
            scope.menuSpecs = {
              position: {left: event.clientX, top: event.clientY},
              type: 'ALLROUND'
            }
          }, 50)
        }

        function openNewContext (newContext) {
          scope.openContextMenu(newContext.event, newContext, {type: newContext.type, title: newContext.title})
        }

        scope.openContextMenu = function (event, context, menuOption){

          $timeout(function  () {
            if (event && context && menuOption) {
              scope.selectedContextMenuItem  =  menuOption;
              scope.contextPosition = { left: event.clientX, top: event.clientY }
              scope.context = context
              scope.resource = scope.printRuleConfig
              scope.auxiliaries = {
                me: scope.me
              };
            } else {
              scope.selectedContextMenuItem  =  null;
              scope.contextPosition = null;
              scope.context = null;
              scope.resource = null
            }
          }, 50)
        }

        scope.closeAllMenus = function (newContext) {
          if (newContext && !newContext.data) {
            openNewContext(newContext)
          } else {
            if (newContext?.data) {
              setConfigs(newContext.data)
            }
            scope.selectedContextMenuItem  =  null;
            scope.contextPosition = null;
            scope.context = null;
            scope.resource = null
          }
        }

        scope.closeGroupsMenu = function (selection, position, content) {
          if (selection) {
            scope.openContextMenu({clientX: position.left, clientY: position.top}, content.context, selection)
          }
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.contextContent = null;
        }

        function setConfigs(data) {
          scope.printRuleConfig = data.printRuleConfiguration;
          scope.tenant.info._embedded.printRuleConfiguration = angular.copy(data.printRuleConfiguration);
          scope.printRuleConfig.embedded = data._embedded;
          scope.printRuleConfig.links = data._links;
          scope.printRuleConfig.rules = {};
          scope.printRuleConfig.ruleList.forEach(function (rule) {
            scope.printRuleConfig.rules[rule.type] = rule;
          })
          scope.setRuleSelections('BLACK_AND_WHITE');
          scope.setRuleSelections('DUPLEX_MODE');
          scope.printRuleConfigPrevious = angular.copy(scope.printRuleConfig);
        }

        function useDefaultPrintRuleConfig() {
          scope.printRuleConfig = {
            tenantId: "",
            enabledPrintRules: true,
            rules: {
              'DUPLEX_MODE': {
                enabled: false,
                type: "DUPLEX_MODE",
                threshold: 0,
                groups: []
              },
              'BLACK_AND_WHITE': {
                enabled: false,
                type: "BLACK_AND_WHITE",
                threshold: 0,
                groups: []
              }
            },
            ruleList:
              [
                {
                  enabled: false,
                  type: "DUPLEX_MODE",
                  threshold: 0,
                  groups: []
                },
                {
                  enabled: false,
                  type: "BLACK_AND_WHITE",
                  threshold: 0,
                  groups: []
                },
              ]
          };
        }

        function getPrintRules() {
          scope.isLoading = true;
          PrintRulesService.getConfig().then(function (data) {
            setConfigs(data);
            scope.isLoading = false;
          }).catch(function (error) {
            toastr.error('There was an error loading the data.')
            useDefaultPrintRuleConfig();
            scope.isLoading = false;
          })
        }

        scope.updatePrintRules = function (rule, key = null) {
          let isRule = rule !== 'root';
          let path = isRule ? `${rule}/${key}` : `${key}`;
          let currentConfig = isRule ? scope.printRuleConfig.rules[rule][key] : scope.printRuleConfig[key];
          let previousConfig = isRule ? scope.printRuleConfigPrevious.rules[rule][key] : scope.printRuleConfigPrevious[key];

          if (currentConfig === previousConfig) {
            return;
          }
          if (key === 'threshold' && !scope.thresholdRegex.test(currentConfig)) {
            scope.printRuleConfig.rules[rule][key] = previousConfig;
            toastr.error($filter("translate")("ErrorOnlyPositiveNumbers"));
            return
          }
          scope.isLoading = true;

          let data = { [path]: currentConfig }

          PrintRulesService.updatePrintRule(data, isRule)
            .then(function (response) {
              setConfigs(response);
              scope.isLoading = false;
              toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function (error) {
              toastr.error($filter("translate")("ERROR"));
              if(rule === 'root'){
                scope.printRuleConfig[key] = scope.printRuleConfigPrevious[key]
              } else {
                scope.printRuleConfig.rules[rule][key] = scope.printRuleConfigPrevious.rules[rule][key];
                scope.setRuleSelections(rule);
              }
              scope.isLoading = false;
          });
        }

        scope.updateGroups = function(payload, isBlackWhiteGroups = true) {
          scope.isLoading = true;
          PrintRulesService.updatePrintRuleGroups(payload, isBlackWhiteGroups)
            .then(function (response) {
              scope.isLoading = false;
              toastr.success($filter("translate")("ChangesSaved"));
              setConfigs(response)
          }).catch(function (error) {
              if (isBlackWhiteGroups) {
                scope.printRuleConfig.embedded.blackWhiteGroups = angular.copy(scope.printRuleConfigPrevious.embedded.blackWhiteGroups);
                scope.setRuleSelections('BLACK_AND_WHITE');
              } else {
                scope.printRuleConfig.embedded.doubleSideGroups = angular.copy(scope.printRuleConfigPrevious.embedded.doubleSideGroups);
                scope.setRuleSelections('DUPLEX_MODE');
              }
              scope.isLoading = false;
              toastr.error($filter("translate")("ERROR"));
          })
        }

        const PRINT_RULE_CONFIGURATION_UPDATED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINT_RULE_CONFIGURATION_UPDATED, function (name, data) {
          getPrintRules();
        });
        const PRINT_RULE_CONFIGURATION_CREATED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINT_RULE_CONFIGURATION_CREATED, function (name, data) {
          getPrintRules();
        });

        scope.$on('$destroy', function () {
          PRINT_RULE_CONFIGURATION_UPDATED_listener();
          PRINT_RULE_CONFIGURATION_CREATED_listener();
        });
      }
    }
  }

  pxPrintRules.$inject = [
    'PrintQueueListPaging', 'PrintRulesService', 'URLS', 'URL_PARAMS', '$location', 'PrintQueueListService',
    'PrinterListService', 'GroupListService', '$timeout', 'toastr', '$filter', 'TenantListService',
    '$rootScope', 'EventServiceEvents', '$q', '$http'
  ];

  angular
    .module('printix-admin')
    .directive('pxPrintRules', pxPrintRules);

})();
